import classnames from 'classnames'
import React from 'react'

import PropTypesHelpers from '@/utils/propTypesHelpers'

import useIsScrollable from '../../utils/hooks/useIsScrollable'

const SiteHeaderContainer = ({ children }) => {
  const scrollable = useIsScrollable()

  return (
    <header className={classnames('site-header', { scrollable })}>
      <div className='site-header-container'>
        {children}
      </div>
    </header>
  )
}

SiteHeaderContainer.propTypes = {
  children: PropTypesHelpers.children
}

export default SiteHeaderContainer
